export const POST_LIST = "POST_LIST";
export const GET_POST = "GET_POST";
